export const cities = [
    "Москва","Владивосток","Уссурийск","Воронеж","Санкт-Петербург","Хабаровск","Екатеринбург",
    "Иркутск","Новосибирск","Самара","Краснодар","Красноярск","Барнаул","Казань","Ростов на Донy",
    "Сочи","Благовещенск","Иванов","Калининград","Махачкала","Нижний Новгород","Нижний Тагил",
    "Новокузнецк","Пермь","Саратов","Улан-Удэ","Уфа","Челябинск","Волгоград","Томск","Омск",
    "Донецк","Ижевск","Кострома","Мариуполь","Набережные Челны","Рязань","Тольятти","Ульяновск",
    "Ставрополь","Адлер","Кемерово","Оренбург","Стерлитамак","Южно-Сахалинск","Ярославль",
    "Брянск","Вологда","Новороссийск","Севастополь","Симферополь","Якутск","Череповец","Мурманск","Находка","Липецк","Online"
];

export const currencies = [
    { value: "USDT", name: "USDT" },
    { value: "JPY", name: "JPY" },
    { value: "KRW", name: "KRW" },
    { value: "CNY", name: "CNY" },
    { value: "THB", name: "THB" },
    { value: "MYR", name: "MYR" },
    { value: "AED", name: "AED" },
    { value: "VND", name: "VND" }
];

export const salaryNames = [
    { value: "MAX VL", name: "MAX VL" },
    { value: "Макс Kor", name: "Макс Kor" },
    { value: "Алексей", name: "Алексей" },
    { value: "Никита", name: "Никита" },
    { value: "Лера", name: "Лера" },
    { value: "Коля", name: "Коля" },
    { value: "CASHOUT", name: "CASHOUT" }
];


export const transferDescriptionItems = [
    { value: "Перевод", name: "Перевод" },
    { value: "Выдача", name: "Выдача" },
    { value: "SELL USDT", name: "SELL USDT" },
    { value: "BUY USDT", name: "BUY USDT" },
    { value: "SWIFT", name: "SWIFT" },
    { value: "Yaharu", name: "Yaharu" },
    { value: "CASH THAILAND", name: "CASH THAILAND" },
    { value: "CASH KOREA", name: "CASH KOREA" },
    { value: "CASH TOKYO", name: "CASH TOKYO" },
    { value: "CASH OSAKA", name: "CASH OSAKA" },
    { value: "CASH NAGOYA", name: "CASH NAGOYA" },
    { value: "CASH TOYAMA", name: "CASH TOYAMA" },
    { value: "CASH SENDAI", name: "CASH SENDAI" },
    { value: "CASH CHIBA", name: "CASH CHIBA" },
    { value: "CNY SELL", name: "CNY SELL" },
    { value: "CASH KOBE", name: "CASH KOBE" },
    { value: "OTHER", name: "Другое" }
];

export const purchaseAmountCurrencies = [
    { value: "RUB", name: "RUB" },
    { value: "USDT", name: "USDT" }
];